var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaneEnRoute(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    id: "Layer_1",
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5192",
    transform: "matrix(0.49999995,0,0,0.49999995,-2750.0002,-4844.6779)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 5614.9123,9880.7308 c -45.6367,0 -82.9114,37.2746 -82.9114,82.8404 l 0,475.4998 c 0,45.566 37.2747,82.912 82.9114,82.912 l 794.1064,0 c 45.5659,0 82.9823,-37.346 82.9823,-82.912 l 0,-475.4998 c 0,-45.5658 -37.4164,-82.8404 -82.9823,-82.8404 l -794.1064,0 z m 0,40.3927 794.1064,0 c 23.8813,0 42.5187,18.5664 42.5187,42.4477 l 0,475.4998 c 0,23.882 -18.6374,42.448 -42.5187,42.448 l -794.1064,0 c -23.8814,0 -42.4478,-18.566 -42.4478,-42.448 l 0,-475.4998 c 0,-23.8813 18.5664,-42.4477 42.4478,-42.4477 z",
    id: "path4030",
    style: {
      fill: "#4d4d4d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5614.9123,9880.7308 c -45.6367,0 -82.9114,37.2746 -82.9114,82.8404 l 0,475.4998 c 0,45.566 37.2747,82.912 82.9114,82.912 l 794.1064,0 c 45.5659,0 82.9823,-37.346 82.9823,-82.912 l 0,-475.4998 c 0,-45.5658 -37.4164,-82.8404 -82.9823,-82.8404 l -794.1064,0 z m 0,40.3927 794.1064,0 c 23.8813,0 42.5187,18.5664 42.5187,42.4477 l 0,475.4998 c 0,23.882 -18.6374,42.448 -42.5187,42.448 l -794.1064,0 c -23.8814,0 -42.4478,-18.566 -42.4478,-42.448 l 0,-475.4998 c 0,-23.8813 18.5664,-42.4477 42.4478,-42.4477 z",
    id: "path4032",
    style: {
      fill: "#4d4d4d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g5184",
    transform: "translate(-0.14566662,-0.34014106)"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 24,
    id: "rect5178",
    rx: 12,
    ry: 12,
    style: {
      fill: "#336699",
      fillOpacity: 1,
      stroke: "none"
    },
    transform: "matrix(0.84640909,-0.53253324,0.53253324,0.84640909,0,0)",
    width: 90,
    x: -515.83618,
    y: 11772.142
  }), /*#__PURE__*/React.createElement("rect", {
    height: 24,
    id: "rect5180",
    rx: 12,
    ry: 12,
    style: {
      fill: "#336699",
      fillOpacity: 1,
      stroke: "none"
    },
    transform: "matrix(0.8129552,-0.58232623,0.58232623,0.8129552,0,0)",
    width: 90,
    x: -1354.7927,
    y: 11717.672
  }), /*#__PURE__*/React.createElement("rect", {
    height: 24,
    id: "rect5182",
    rx: 12,
    ry: 12,
    style: {
      fill: "#336699",
      fillOpacity: 1,
      stroke: "none"
    },
    transform: "matrix(0.78576501,-0.61852514,0.61852514,0.78576501,0,0)",
    width: 90,
    x: -2016.6205,
    y: 11642.02
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 6128.1514,10075.79 c -5.4433,-0.282 -12.0422,1.068 -18.6852,4.553 l -36.0617,18.913 -93.914,-39.956 c -0.4346,-0.185 -0.9518,-0.163 -1.3699,0.05 l -15.86,8.318 c -0.4517,0.242 -0.7746,0.704 -0.8354,1.214 -0.061,0.509 0.1319,1.048 0.5148,1.389 l 62.0736,54.883 -32.2814,16.931 -27.5035,-11.635 c -0.4344,-0.186 -0.9463,-0.167 -1.3647,0.05 l -12.5053,6.559 c -0.4563,0.239 -0.7877,0.711 -0.8511,1.223 -0.063,0.512 0.1386,1.05 0.5229,1.393 l 29.2385,26.175 4.9102,38.935 c 0.063,0.511 0.3913,0.983 0.8483,1.221 0.4569,0.238 1.0339,0.235 1.4897,0 l 12.5052,-6.558 c 0.4181,-0.22 0.7244,-0.63 0.8193,-1.092 l 6.0646,-29.241 32.2815,-16.931 9.8586,82.267 c 0.063,0.508 0.3968,0.973 0.8506,1.213 0.4535,0.239 1.0184,0.238 1.4738,0 l 15.8602,-8.319 c 0.4179,-0.218 0.7297,-0.632 0.8247,-1.094 l 20.5227,-99.975 36.0616,-18.913 c 6.6432,-3.485 11.503,-8.148 14.3678,-12.785 2.8652,-4.637 3.8761,-9.38 1.9697,-13.015 -1.9063,-3.634 -6.3832,-5.5 -11.8268,-5.778 z",
    id: "path5163",
    style: {
      fontSize: "medium",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      lineHeight: "normal",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      direction: "ltr",
      blockProgression: "tb",
      writingMode: "lr-tb",
      textAnchor: "start",
      baselineShift: "baseline",
      color: "#4d4d4d",
      fill: "#336699",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 8,
      marker: "none",
      visibility: "visible",
      display: "inline",
      overflow: "visible",
      enableBackground: "accumulate",
      fontFamily: "Sans",
      InkscapeFontSpecification: "Sans"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 24,
    id: "rect5174",
    rx: 12,
    ry: 12,
    style: {
      fill: "#336699",
      fillOpacity: 1,
      stroke: "none"
    },
    transform: "matrix(0.94645834,-0.32282599,0.32282599,0.94645834,0,0)",
    width: 90,
    x: 2609.5698,
    y: 11511.082
  }), /*#__PURE__*/React.createElement("rect", {
    height: 24,
    id: "rect5176",
    rx: 12,
    ry: 12,
    style: {
      fill: "#336699",
      fillOpacity: 1,
      stroke: "none"
    },
    transform: "matrix(0.97669054,-0.21465223,0.21465223,0.97669054,0,0)",
    width: 90,
    x: 4016.3372,
    y: 11132.797
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaneEnRoute);
export default __webpack_public_path__ + "static/media/PlaneEnRoute.78e4f9a5.svg";
export { ForwardRef as ReactComponent };